/**
 * The status a retailer sees on a HandOff invoice.
 *
 * Payment lives on the monthly settlement, not on the invoice (two-supply-netting spec §6):
 * the invoice and the self-billed invoice are set off against each other and one statement
 * carries the single payment. So an invoice's status is its statement's status.
 */

export const SETTLEMENT_STATUS_LABELS = {
  open: 'Open',
  overdue: 'Overdue',
  disputed: 'Disputed',
  settled: 'Settled',
  cancelled: 'Cancelled',
};

export const SETTLEMENT_STATUS_COLORS = {
  open: 'warning',
  overdue: 'error',
  disputed: 'error',
  settled: 'success',
  cancelled: 'default',
};

// Filter values understood by GET /api/retailer/v1/invoices?status=
export const SETTLEMENT_STATUS_FILTERS = [
  ['issued', 'Open'],
  ['overdue', 'Overdue'],
  ['disputed', 'Disputed'],
  ['settled', 'Settled'],
];

/** One display key for an invoice row: open | overdue | disputed | settled | cancelled. */
export function invoiceStatusKey(invoice) {
  if (!invoice) return 'open';
  if (invoice.document_status === 'cancelled') return 'cancelled';
  if (invoice.settlement_status === 'settled') return 'settled';
  if (invoice.settlement_status === 'disputed') return 'disputed';
  if (invoice.is_overdue) return 'overdue';
  return 'open';
}

/** One display key for a statement row from GET /api/retailer/v1/settlements. */
export function statementStatusKey(statement) {
  if (!statement) return 'open';
  if (statement.status === 'cancelled') return 'cancelled';
  if (statement.status === 'settled') return 'settled';
  if (statement.status === 'disputed') return 'disputed';
  if (statement.is_overdue) return 'overdue';
  return 'open';
}

export const NET_DIRECTION_LABELS = {
  retailer_to_handoff: 'You pay HandOff',
  handoff_to_retailer: 'HandOff pays you',
  balanced: 'Nothing to pay',
};

/** Short, second-person label for who pays whom on a statement. */
export function netDirectionLabel(statement) {
  return NET_DIRECTION_LABELS[statement?.net_direction] || NET_DIRECTION_LABELS.balanced;
}
